import { useTranslation } from "react-i18next";

import "./styles.scss";

export default function Offline() {
  const { t } = useTranslation();

  return <div className="offline-bar">{t("NO_CONNECTION")}</div>;
}
